import { Variation } from '@/@core/services/app.service'
import { TableColumnsType } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Stack,
  Typography,
  Box,
  Chip,
  IconButton,
  Badge,
  Slide
} from '@mui/material'
import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import { styled } from '@mui/material/styles'
import CommentOutline from 'mdi-material-ui/CommentOutline'
import { ExternalLinks } from '@/@core/services/api'
import {
  ChevronDown,
  ChevronRight,
  Circle,
  CircleHalfFull,
  MenuDown
} from 'mdi-material-ui'
import {
  addCommas,
  chromosomeRegion,
  formatVariantInheritance,
  isJson,
  isWindow,
  renameChildTypes,
  unique
} from '@/@core/utils/utils'
import { useRouter } from 'next/router'
import { Rating } from '@mui/material'

interface Props {
  setCurrent: any
  data: any[]
  setColumn1: any
}
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

export const judgeType = (str: string, arr: any[]) => {
  if (str.includes('child') && !str.includes('//')) {
    return 'C'
  } else if (str.includes('child') && str.includes('//')) {
    return `C${str.split('//')[1]}`
  } else if (str.includes('mother')) {
    return 'M'
  } else if (str.includes('father')) {
    return 'F'
  } else {
    return 'O'
  }
}

const columns1ThalassemiaPlot = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()
  const ability = useContext(AbilityContext)

  const router = useRouter()

  const { id, ids, group } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'

  const column: ColumnDef<Variation>[] = React.useMemo(() => {
    return [
      {
        accessorKey: 'Regions',
        id: 'Regions',
        enableSorting: false,
        header: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Regions')}
              </span>
            </Stack>
          </Stack>
        ),
        cell: ({ row, getValue }: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>Copy Number</TypographyA>
            </Stack>
          )
        },
        footer: (props) => props.column.id
      },
      {
        accessorKey: 'mean_cn',
        id: 'mean_cn',
        enableSorting: false,
        header: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Mean')}
              </span>
            </Stack>
          </Stack>
        ),
        cell: ({ row, getValue }: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>{row.original.mean_cn}</TypographyA>
            </Stack>
          )
        },
        footer: (props) => props.column.id
      },
      ...props.data.map((items) => {
        return {
          accessorKey: items.name,
          id: items.name,
          enableSorting: false,
          header: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {items.name}
                </span>
              </Stack>
            </Stack>
          ),
          cell: ({ row, getValue }: any) => {
            if (items.name === row.original.name)
              return (
                <Stack
                  width={'100%'}
                  marginTop={'12px'}
                  direction="column"
                  alignItems="start"
                >
                  <HtmlTooltip
                    title={
                      <Box maxHeight={300} overflow="auto">
                        <Typography color={'white'}>
                          {items?.overlapping_records
                            ?.map((i: any) => i['raw.cn'])
                            .join(';')}
                        </Typography>
                      </Box>
                    }
                  >
                    <TypographyA
                      sx={{
                        maxWidth: 150,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      {items?.overlapping_records
                        ?.map((i: any) => i['raw.cn'])
                        .join(';')}
                    </TypographyA>
                  </HtmlTooltip>
                </Stack>
              )
            else return ''
          },
          footer: (props: any) => props?.column.id
        }
      })
    ]
  }, [props.data])

  React.useEffect(() => {
    //)

    props.setColumn1(column)
  }, [column])

  // React.useImperativeHandle(ref, () => ({
  //   column
  // }))

  return <></>
})

export default columns1ThalassemiaPlot
